import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { appt_type_images, convertToNgbDate, datePickerMinDate, isSCCase, triageList } from '../../shared/constants';
import { debounceTime } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addDays, isBefore } from 'date-fns';

@Component({
	selector: 'app-company-appt-details',
	templateUrl: './company-appt-details.component.html',
	styleUrl: './company-appt-details.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class CompanyApptDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/comp/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	caseDetails: any = {};
	subsymptoms: any = [];
	followupList: any = [];
	loadingFollowUp = true;
	File_Storage_URL = environment.File_Storage_URL;
	triageCode: any = null;
	triageList = triageList;
	updateLoader = false;
	minDate = datePickerMinDate;
	activeTab: any = 0;
	showDeleteLoader: any = null;
	/* followUpBillsData: any[] = [];
	loadingBilling = false; */
	showLoader = false;
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	case_category_id: any = null;
	work_related = false;
	showClosureFields = false;
	tblCollapseHeightCaseDetails = "250px";
	tblCollapseHeight = "";
	currentURLSegment = "";
	assigned_sc_agent_id: any = null;
	mark_for_closure = false;
	ready_to_bill = false;
	hospStatusList: any = [];
	surgeryStatusList: any = [];
	loadingReminders = false;
	caseReminder: any = null;
	/* loadingFeedback = false;
	feedbackQuestions: any[] = []; */

	billingMaxDate = convertToNgbDate(new Date());
	appt_type_images = appt_type_images;

	/* loadingHandover = false;
	nonMedicalList: any[] = []; */
	isSCCase = isSCCase;

	constructor(private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService) {
		this.apiService.getFollowUpFilesRefreshEvent().subscribe({
			next: (val) => {
				if(val){
					this.getCaseDetails();
				}
			}
		});
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.activeRoute.url.subscribe((val) => {
				this.currentURLSegment = val[0].path;
				this.uId = routeParams["uId"];
				this.breadcrumbList.push({ path: "/comp/" + this.currentURLSegment + "/" + this.uId, name: "Appointment Details" });
				this.getCaseDetails();
				this.getFollowup();
				this.getAllFollowUpStatus();
			});
		});
	}

	ngAfterViewInit(): void { }

	ngOnDestroy(): void { }

	getTabClass(tabNum: any) {
		if (this.activeTab == tabNum) {
			return "active";
		} else {
			return "";
		}
	};

	setActiveTab(tabNum: any) {
		this.activeTab = tabNum;
		if (tabNum == 0) {
			this.getFollowup();
		} else if (tabNum == 1) {
			/* this.getFolloupBillsByCase(); */
		} else if (tabNum == 2) {
			/* this.getFeedback(); */
		} else if (tabNum == 3) {
			/* this.getHandover(); */
		}
	};

	getTabPaneClass(tabNum: any) {
		if (this.activeTab == tabNum) {
			return "tab-pane active";
		} else {
			return "tab-pane";
		}
	}

	getTriage(val: any) {
		return this.triageList.find((triage) => triage.val == val) || { color: "dark-custom", text: "Assign Triage" };
	}

	getCaseDetails() {
		this.getCaseReminders();
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				data["expected_closure_date_display"] = data["expected_closure_date"];
				data["surgery_date_display"] = data["surgery_date"];
				data["hospitalized_date_display"] = data["hospitalized_date"];
				data["expected_closure_date"] = this.apiService.getDateFromDateString(data["expected_closure_date"]);
				data["surgery_date"] = this.apiService.getDateFromDateString(data["surgery_date"]);
				data["hospitalized_date"] = this.apiService.getDateFromDateString(data["hospitalized_date"]);
				this.caseDetails = data;
				this.mark_for_closure = this.caseDetails.mark_for_closure;
				this.ready_to_bill = this.caseDetails.ready_to_bill;
				this.triageCode = this.caseDetails.triage;
				this.assigned_sc_agent_id = this.caseDetails.assigned_sc_agent?.id;
				this.work_related = this.caseDetails.work_related;
				this.case_category_id = this.caseDetails.case_category_id ? parseInt(this.caseDetails.case_category_id) : null;
				this.subsymptoms = data.sub_symptoms != null ? Object.keys(data.sub_symptoms).map(key => data.sub_symptoms[key]) : [];
				/* this.getFolloupBillsByCase(); */
			}, error: (error) => {
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getFollowup() {
		this.apiService.getFollowupList({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.loadingFollowUp = false;
				this.followupList = data.data;
				if (!this.activeRoute.children.length && this.followupList.length) {
					/* this.router.navigate(['/comp/' + this.currentURLSegment, this.uId, this.followupList[0].enc_id]); */
					this.router.navigate([this.followupList[0].enc_id], { relativeTo: this.activeRoute });
				}
			}, error: (error) => {
				this.loadingFollowUp = false;
				this.followupList = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getFileName(path: string) {
		try {
			return path.split("/").pop() || "";
		} catch (error) {
			return path;
		}
	}

	/* getFolloupBillsByCase() {
		this.loadingBilling = true;
		this.apiService.getFolloupBillsByCase({ id: this.caseDetails.id }).subscribe({
			next: (data: any) => {
				data.data.map((bill: any) => {
					bill.files = bill.files === null ? [] : bill.files;
					bill.gpay_files = bill.gpay_files === null ? [] : bill.gpay_files;
					bill.qrcode_files = bill.qrcode_files === null ? [] : bill.qrcode_files;
					return bill
				});
				this.loadingBilling = false;
				this.followUpBillsData = data.data;
			}, error: (error) => {
				this.loadingBilling = false;
				this.followUpBillsData = [];
			}
		})
	} */

	getFollowUpStatusClass(statusId: any) {
		if (statusId == 2) {
			return "bg-success";
		} else if (statusId == 1) {
			return "bg-warning";
		} else {
			return "bg-danger";
		}
	}

	getClass(value: number): string {
		if (value < 90) {
			return 'bg-success';
		} else if (value >= 90 && value <= 130) {
			return 'bg-warning-custom';
		} else {
			return 'bg-danger';
		}
	}

	reverseDate(dateStr: string) {
		if (dateStr) {
			try {
				return dateStr.split("-").reverse().join("-");
			} catch (error) {
				return dateStr;
			}
		} else {
			return dateStr;
		}
	}

	isKeyEvalIncomplete() {
		try {
			if (
				/* this.caseDetails?.hospitalized_required &&
				this.caseDetails?.surgery_required && */
				this.caseDetails?.disability &&
				this.caseDetails?.expected_closure_date &&
				this.caseDetails?.icd_code &&
				this.caseDetails?.diagnosis
			) {
				if (this.caseDetails?.disability == "Yes" && !this.caseDetails?.disability_per) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		} catch (error) {
			return true;
		}
	}

	showHospitalizationDate() {
		return this.caseDetails?.hospitalized_required == 'Yes' || this.caseDetails?.hospitalized_required == 'Discharged' ? true : false;
	}

	showSurgeryDate() {
		return this.caseDetails?.surgery_required == 'Yes' ? true : false;
	}

	showDisabilityFields() {
		return this.caseDetails?.disability == 'Yes' || this.caseDetails?.disability == 'Limited' ? true : false;
	}

	getAllFollowUpStatus() {
		this.apiService.getAllFollowUpStatus().subscribe({
			next: (data: any) => {
				let groupedData = data.data.reduce((prev: any, current: any) => {
					const key = current.category;
					if (!prev[key]) {
						prev[key] = [];
					}
					prev[key].push(current);
					return prev;
				}, {});
				this.hospStatusList = groupedData.Hospitalization;
				this.surgeryStatusList = groupedData.Surgery;
			}, error: (error) => {
				this.hospStatusList = [];
				this.surgeryStatusList = [];
			},
		});
	}

	getFrequencyText(obj: any) {
		let textArr: any = [];
		if (obj.morning) {
			textArr.push("Morning");
		}
		if (obj.afternoon) {
			textArr.push("Afternoon");
		}
		if (obj.evening) {
			textArr.push("Evening");
		}
		if (obj.sos) {
			textArr.push("SOS");
		}
		return textArr.join(", ");
	}

	getCaseReminders() {
		this.loadingReminders = true;
		this.apiService.getCaseReminders(this.uId).subscribe({
			next: (data: any) => {
				this.loadingReminders = false;
				this.caseReminder = data;
			}, error: (error) => {
				this.loadingReminders = false;
				this.caseReminder = null;
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	/* getFeedback() {
		this.loadingFeedback = true;
		this.apiService.getFeedbackQuestions(this.uId).subscribe({
			next: (data: any) => {
				this.loadingFeedback = false;
				let listMain: any[] = [];
				let listSub: any[] = [];
				let len1 = data[1].length;
				let len2 = data[0].length;
				for (let i = 0; i < len1; i++) {
					for (let j = 0; j < len2; j++) {
						if (data[1][i].que_id == data[0][j].quetion) {
							data[1][i].ans_given = data[0][j].ans_given;
							data[1][i].other_text = data[0][j].other_text;
						}
					}
					if (data[1][i].parent_id) {
						listSub.push(data[1][i]);
					} else {
						data[1][i].sub_questions = [];
						listMain.push(data[1][i]);
					}
				}
				let len3 = listMain.length;
				let len4 = listSub.length;
				for (let i = 0; i < len3; i++) {
					for (let j = 0; j < len4; j++) {
						if (listMain[i].que_id == listSub[j].parent_id) {
							listMain[i].sub_questions.push(listSub[j])
						}
					}
				}
				this.feedbackQuestions = listMain;
			}, error: (error) => {
				this.loadingFeedback = false;
				this.feedbackQuestions = [];
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	} */

	showOtherInput(ans_given: any, options: any[]) {
		for (let i = 0; i < options.length; i++) {
			if (options[i].value === ans_given && options[i].display_name === "Other") {
				return true;
			}
		}
		return false;
	}

	modalNotesDetail: any = {
		heading: null,
		note: null
	};

	showInModal(heading: any, note: any) {
		this.modalNotesDetail.heading = heading;
		this.modalNotesDetail.note = note;
		$("#displayNoteModal").modal("show");
	}

	showHospModal() {
		$("#hospitalizationViewModal").modal("show");
	}

	showSurgModal() {
		$("#surgeryViewModal").modal("show");
	}

	showDisabilityModal() {
		$("#disabilityViewModal").modal("show");
	}

	showPhysioModal() {
		$("#physiotherapyViewModal").modal("show");
	}

	unlinkFromHC() {
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to unlink case from HC?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Unlink',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.apiService.unlinkFromHC(this.uId).subscribe({
					next: (response: any) => {
						this.toastr.success("Unlinked from HC", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.getCaseDetails();
					}, error: (error) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	getPortVisitText(val: any) {
		if (val == "No" || val == false || !val) {
			return "NA";
		} else {
			return val;
		}
	}

	/* getHandover() {
		if (this.uId) {
			this.loadingHandover = true;
			this.apiService.getFollowupList({ id: this.uId, type: 5 }).subscribe({
				next: (data: any) => {
					this.loadingHandover = false;
					this.nonMedicalList = data.data;
				}, error: (error) => {
					this.loadingHandover = false;
					this.nonMedicalList = [];
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				},
			});
		}
	} */
}
